<div class="fc-app-shell">

  <!-- ─── Sidebar ─────────────────────────────────────── -->
  <aside class="fc-sidebar">

    <div class="fc-sidebar-brand">
      <img src="assets/images/deFault_logo_Fabricode_Black.png" alt="Fabricode" class="fc-brand-word" />
    </div>

    <div class="fc-sidebar-scroll">
      <div class="fc-nav-section-label">Workspace</div>
      <ul class="fc-nav-list">

        <li class="fc-nav-item" [class.is-active]="selectedTabIndex === 1" (click)="selectedTabIndex = 1">
          <span class="material-icons fc-nav-icon">home</span>
          <span class="fc-nav-label">Main</span>
        </li>

        <li class="fc-nav-item" [class.is-active]="selectedTabIndex === 2" (click)="selectedTabIndex = 2">
          <span class="material-icons fc-nav-icon">assessment</span>
          <span class="fc-nav-label">Machine</span>
        </li>

        <li *appFeatureEnabled="'FEAT_DEPARTMENT'"
            class="fc-nav-item" [class.is-active]="selectedTabIndex === 3" (click)="selectedTabIndex = 3">
          <span class="material-icons fc-nav-icon">group_work</span>
          <span class="fc-nav-label">Department</span>
        </li>

        <li *appFeatureEnabled="'FEAT_JOB_ORDER'"
            class="fc-nav-item" [class.is-active]="selectedTabIndex === 4" (click)="selectedTabIndex = 4">
          <span class="material-icons fc-nav-icon">event</span>
          <span class="fc-nav-label">Job</span>
        </li>

        <li *appFeatureEnabled="'FEAT_DATA_STUDIO_REPORT'"
            class="fc-nav-item" [class.is-active]="selectedTabIndex === 5" (click)="selectedTabIndex = 5">
          <span class="material-icons fc-nav-icon">bar_chart</span>
          <span class="fc-nav-label">Reports</span>
        </li>

        <li *appFeatureEnabled="'FEAT_DOCUMENTATION'"
            class="fc-nav-item" [class.is-active]="selectedTabIndex === 6" (click)="selectedTabIndex = 6">
          <span class="material-icons fc-nav-icon">folder</span>
          <span class="fc-nav-label">Documentation</span>
        </li>

        <li *appFeatureEnabled="'FEAT_OPERATIONS'"
            class="fc-nav-item" [class.is-active]="selectedTabIndex === 8" (click)="selectedTabIndex = 8">
          <span class="material-icons fc-nav-icon">people</span>
          <span class="fc-nav-label">Operations</span>
        </li>

        <li *appHasRole="['ROLE_ROOT', 'ROLE_ADMIN']"
            class="fc-nav-item" [class.is-active]="selectedTabIndex === 7" (click)="selectedTabIndex = 7">
          <span class="material-icons fc-nav-icon">settings</span>
          <span class="fc-nav-label">Settings</span>
        </li>

      </ul>

      <ng-container *appFeatureEnabled="'FEAT_FABRICODE_PLUS'">
        <div class="fc-nav-section-label fc-nav-section-label--mt">External</div>
        <ul class="fc-nav-list">
          <li class="fc-nav-item">
            <span class="material-icons fc-nav-icon">open_in_new</span>
            <a href="{{ fabricodePlusPath }}/#/?autologin-payload={{ encodedLoggedUser }}"
               target="_blank" class="fc-nav-label fc-external-link">Fabricode+</a>
          </li>
        </ul>
      </ng-container>
    </div>

    <div class="fc-sidebar-footer">
      <ng-container *ngIf="customer$ | async as customer">
        <div class="fc-user-avatar">{{ customer.name.charAt(0) }}</div>
        <div class="fc-user-meta">
          <span class="fc-uname">{{ customer.name }}</span>
        </div>
      </ng-container>
      <a href="/login" class="fc-sidebar-logout" title="Logout">
        <span class="material-icons">logout</span>
      </a>
    </div>

  </aside>

  <!-- ─── Main area ─────────────────────────────────────── -->
  <div class="fc-main">

    <!-- Topbar -->
    <div class="fc-topbar">
      <div class="fc-topbar-title">
        <ng-container [ngSwitch]="selectedTabIndex">
          <h1 *ngSwitchCase="1">Main</h1>
          <h1 *ngSwitchCase="2">Machine</h1>
          <h1 *ngSwitchCase="3">Department</h1>
          <h1 *ngSwitchCase="4">Job orders</h1>
          <h1 *ngSwitchCase="5">Reports</h1>
          <h1 *ngSwitchCase="6">Documentation</h1>
          <h1 *ngSwitchCase="7">Settings</h1>
          <h1 *ngSwitchCase="8">Operations</h1>
          <h1 *ngSwitchDefault>Fabricode</h1>
        </ng-container>
      </div>
      <div class="fc-topbar-spacer"></div>
      <div class="fc-topbar-cluster">
        <app-env-info></app-env-info>
      </div>
    </div>

    <!-- Page content -->
    <div class="fc-content">

      <div class="fc-page" *ngIf="selectedTabIndex === 1">
        <app-main-component
          *ngIf="listOfMachinesFromApi && machineStates && machineEnergy"
          [machinesFromApi]="listOfMachinesFromApi"
          [machineStates]="machineStates"
          [machineEnergy]="machineEnergy"
        ></app-main-component>
      </div>

      <div class="fc-page" *ngIf="selectedTabIndex === 2">
        <app-machines-component
          *ngIf="listOfMachinesFromApi.length"
          [listOfMachinesFromApi]="listOfMachinesFromApi"
        ></app-machines-component>
      </div>

      <ng-container *appFeatureEnabled="'FEAT_DEPARTMENT'">
        <div class="fc-page" *ngIf="selectedTabIndex === 3">
          <app-departments-component
            *ngIf="listOfDepartmentsFromApi.length"
            [listOfDepartmentsFromApi]="listOfDepartmentsFromApi"
          ></app-departments-component>
        </div>
      </ng-container>

      <ng-container *appFeatureEnabled="'FEAT_JOB_ORDER'">
        <div class="fc-page" *ngIf="selectedTabIndex === 4">
          <app-job-orders-component></app-job-orders-component>
        </div>
      </ng-container>

      <ng-container *appFeatureEnabled="'FEAT_DATA_STUDIO_REPORT'">
        <div class="fc-page" *ngIf="selectedTabIndex === 5">
          <app-data-studio-report-component></app-data-studio-report-component>
        </div>
      </ng-container>

      <ng-container *appFeatureEnabled="'FEAT_DOCUMENTATION'">
        <div class="fc-page" *ngIf="selectedTabIndex === 6">
          <app-documentation-component
            *ngIf="listOfMachinesFromApi.length"
            [listOfMachinesFromApi]="listOfMachinesFromApi"
          ></app-documentation-component>
        </div>
      </ng-container>

      <ng-container *appHasRole="['ROLE_ROOT', 'ROLE_ADMIN']">
        <div class="fc-page" *ngIf="selectedTabIndex === 7">
          <app-settings-component
            (machinesAddedOrUpdated)="onMachinesAddedOrUpdated()"
          ></app-settings-component>
        </div>
      </ng-container>

      <ng-container *appFeatureEnabled="'FEAT_OPERATIONS'">
        <div class="fc-page" *ngIf="selectedTabIndex === 8">
          <app-operations-component
            [listOfMachinesFromApi]="listOfMachinesFromApi"
          ></app-operations-component>
        </div>
      </ng-container>

    </div>

    <app-footer-component></app-footer-component>

  </div>

</div>
